import React from "react";
import { PrimaryButton } from "../../../styles/colors";
// import Pagination from "@material-ui/lab/Pagination";
import ReactPaginate from "react-paginate";
import "./footer.css";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
export const Footer = ({
  total,
  handlePage,
  page,
  startEntry,
  endEntry,
  tableFor,
}) => {
  const { t } = useTranslation();
  const handlePageClick = (data) => {
    handlePage(data.selected);
  };
  total = tableFor === "users" ? total - 1 : total;
  endEntry = tableFor === "users" ? endEntry - 1 : endEntry;
  startEntry = tableFor === "transactions" && total === 0 ? 0 : startEntry;

  return (
    <div className={tableFor === "users" ? "table-footer" : "table-footer2"}>
      <Typography>
        {t("text_showing")} {startEntry} {t("text_to")} {endEntry}{" "}
        {t("text_of")} {total} {t("text_entries")}
      </Typography>
      <ReactPaginate
        forcePage={page}
        previousLabel={t("text_prev")}
        nextLabel={t("text_next")}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={Math.ceil(total / 10)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={2}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
        previousClassName="previous-button"
        nextLinkClassName="next-button"
        pageLinkClassName={"page-link"}
        activeLinkClassName="active-page-link"
      />
    </div>
  );
};
